import { SapService } from '../services/api';

// Fecha de hoy (YYYY-MM-DD) en la hora local del equipo. toISOString() usa UTC y,
// desde las 7 p. m. en Colombia, devuelve la fecha del día siguiente.
export const fechaLocalHoy = () => {
  const hoy = new Date();
  return `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}-${String(hoy.getDate()).padStart(2, '0')}`;
};

export const idGrupoPlanificacionOptions = [
  { label: "MATERIA PRIMA (DESMOL)", value: "1-1" },
  { label: "MRO", value: "1-2" },
  { label: "IMPORTACIONES EUROPA", value: "1-3" },
  { label: "IMPORTACIONES AMÉRICA Y ASIA", value: "1-4" },
  { label: "NACIONAL COMERCIAL", value: "1-5" },
  { label: "CONSUMO INTERNO (GASTOS)", value: "1-6" },
  { label: "EQUIPOS FABRICADOS", value: "1-7" },
  { label: "PRODUCCION", value: "1-8" }
];

export const categoryOptions = [
];

export const lineaKUTOptions = [
  { label: "Carne", value: "101" },
  { label: "Pan y Chocolate", value: "102" },
  { label: "Horeca", value: "103" },
  { label: "Agroindustrial", value: "104" },
  { label: "Café", value: "105" },
  { label: "No Food", value: "106" },
  { label: "Chocolate", value: "107" },
  { label: "Consumos propios", value: "108" },
  { label: "Repuestos", value: "109" },
  { label: "Lácteos", value: "110"}
];

export const codigosProveedores = [
  { idproveedor: "7000000094", value: "100" },
  { idproveedor: "7000000090", value: "101" },
  { idproveedor: "7000000087", value: "102" },
  { idproveedor: "7000000024", value: "103" },
  { idproveedor: "7000000108", value: "104" },
  { idproveedor: "7000000066", value: "105" },
  { idproveedor: "7000000167", value: "106" },
  { idproveedor: "7000000135", value: "107" },
  { idproveedor: "7000000011", value: "108" },
  { idproveedor: "7000000088", value: "109" },
  { idproveedor: "7000000137", value: "110" },
  { idproveedor: "7000000023", value: "111" },
  { idproveedor: "7000000078", value: "112" },
  { idproveedor: "7000000049", value: "113" },
  { idproveedor: "7000000041", value: "114" },
  { idproveedor: "7000000081", value: "115" },
  { idproveedor: "7000000130", value: "116" },
  { idproveedor: "7000000037", value: "117" },
  { idproveedor: "7000000136", value: "118" },
  { idproveedor: "7000000092", value: "119" },
  { idproveedor: "7000000097", value: "120" },
  { idproveedor: "7000000068", value: "121" },
  { idproveedor: "7000000107", value: "122" },
  { idproveedor: "7000000060", value: "123" },
  { idproveedor: "7000000077", value: "124" },
  { idproveedor: "7000000122", value: "125" },
  { idproveedor: "7000000121", value: "126" },
  { idproveedor: "7000000043", value: "127" },
  { idproveedor: "7000000056", value: "128" },
  { idproveedor: "7000000021", value: "130" },
  { idproveedor: "7000000082", value: "131" },
  { idproveedor: "7000000114", value: "132" },
  { idproveedor: "7000000112", value: "133" },
  { idproveedor: "7000000057", value: "134" },
  { idproveedor: "7000000036", value: "135" },
  { idproveedor: "7000000125", value: "136" },
  { idproveedor: "7000000016", value: "137" },
  { idproveedor: "7000000143", value: "138" },
  { idproveedor: "7000000115", value: "139" },
  { idproveedor: "7000000136", value: "140" },
  { idproveedor: "7000000131", value: "141" },
  { idproveedor: "7000000109", value: "142" },
  { idproveedor: "7000000141", value: "143" },
  { idproveedor: "7000000084", value: "144" },
  { idproveedor: "7000000059", value: "145" },
  { idproveedor: "7000000083", value: "146" },
  { idproveedor: "7000000063", value: "147" },
  { idproveedor: "7000000086", value: "148" },
  { idproveedor: "7000000119", value: "149" },
  { idproveedor: "7000000089", value: "150" },
  { idproveedor: "7000000091", value: "151" },
  { idproveedor: "7000000001", value: "152" },
  { idproveedor: "7000000002", value: "153" },
  { idproveedor: "7000000134", value: "154" },
  { idproveedor: "7000000050", value: "155" },
  { idproveedor: "7000000042", value: "156" },
  { idproveedor: "7000000105", value: "157" },
  { idproveedor: "7000000126", value: "158" },
  { idproveedor: "7000000013", value: "159" },
  { idproveedor: "7000000071", value: "160" },
  { idproveedor: "7000000128", value: "161" },
  { idproveedor: "7000000019", value: "162" },
  { idproveedor: "7000000045", value: "163" },
  { idproveedor: "7000000005", value: "164" },
  { idproveedor: "7000000075", value: "165" },
  { idproveedor: "7000000113", value: "166" },
  { idproveedor: "7000000029", value: "168" },
  { idproveedor: "7000000079", value: "169" },
  { idproveedor: "7000000025", value: "170" },
  { idproveedor: "7000000015", value: "171" },
  { idproveedor: "7000000014", value: "172" },
  { idproveedor: "7000000061", value: "173" },
  { idproveedor: "7000000162", value: "174" },
  { idproveedor: "7000000018", value: "176" },
  { idproveedor: "7000000054", value: "177" },
  { idproveedor: "7000000051", value: "178" },
  { idproveedor: "7000000062", value: "179" },
  { idproveedor: "7000000069", value: "180" },
  { idproveedor: "7000000047", value: "181" },
  { idproveedor: "7000000142", value: "182" },
  { idproveedor: "7000000020", value: "183" },
  { idproveedor: "7000000017", value: "184" },
  { idproveedor: "7000000044", value: "185" },
  { idproveedor: "7000000117", value: "187" },
  { idproveedor: "7000000052", value: "188" },
  { idproveedor: "7000000146", value: "192" },
  { idproveedor: "7000000010", value: "193" },
  { idproveedor: "7000000008", value: "194" },
  { idproveedor: "7000000150", value: "195" },
  { idproveedor: "7000000085", value: "196" },
  { idproveedor: "7000000027", value: "198" },
  { idproveedor: "7000000058", value: "199" },
  { idproveedor: "7000000106", value: "200" },
  { idproveedor: "7000000123", value: "201" },
  { idproveedor: "7000000139", value: "202" },
  { idproveedor: "7000000022", value: "203" },
  { idproveedor: "7000000038", value: "204" },
  { idproveedor: "7000000098", value: "205" },
  { idproveedor: "7000000158", value: "208" },
  { idproveedor: "7000000100", value: "209" },
  { idproveedor: "3000000001", value: "901" },
  { idproveedor: "3000000005", value: "902" },
  { idproveedor: "3000000002", value: "903" },
  { idproveedor: "3000000003", value: "904" },
  { idproveedor: "3000000004", value: "905" },
];


export const grupoAlmacenamientoOptions = [
  { nombre: "MAQUINARIA Y EQUIPO", codigo: "1-1" },
  { nombre: "CONSUMIBLES", codigo: "1-2" },
  { nombre: "ACCESORIOS", codigo: "1-3" },
  { nombre: "MATERIA PRIMA", codigo: "1-4" },
  { nombre: "REPUESTOS", codigo: "1-5" },
  { nombre: "CONSUMOS PROPIOS", codigo: "1-6" }
];

export const baseMeasureUnitCodeOptions = [];


export async function fetchCodigosProveedores() {
  try {
    const url = "https://consumos.talsa.com.co/api/talsa/materiales/codproveedores";
    const response = await fetch(url);
    const data = await response.json();
    // Mapea a la estructura original: 
    return data.map((item) => ({
      idproveedor: item.ID,
      value: item.ProveedorSku,
      proveedor: item.Proveedor,
      prevision: item.Prevision,
    }));
  } catch (error) {
    console.error("Error al obtener proveedores:", error);
    return [];
  }
}


export async function fetchValoracionCodeOptions() {
  try {
    const token = await SapService.login();
    const response = await SapService.getData(
      "https://my360131.sapbydesign.com/sap/byd/odata/cust/v1/vmumaterialvaluationdata/MaterialValuationDataAccountDeterminationSpecificationCollection?$format=json",
      token
    );

    return response.d.results.map((element) => ({
      value: element.AccountDeterminationMaterialValuationDataGroupCode,
      label: element.AccountDeterminationMaterialValuationDataGroupCodeText,
    }));
  } catch (error) {
    console.error("Error al obtener datos de unidades de medida:", error);
    return [];
  }
}



export async function fetchBaseMeasureUnitCodeOptions() {
  try {
    const token = await SapService.login();
    const response = await SapService.getData(
      "https://my360131.sapbydesign.com/sap/byd/odata/cust/v1/khunidadmaterial/LogisticUnitMeasureUnitCodeCollection?$format=json",
      token
    );

    return response.d.results.map((element) => ({
      value: element.Code,
      nombre: element.Description,
    }));
  } catch (error) {
    console.error("Error al obtener datos de unidades de medida:", error);
    return [];
  }
}


export async function fetchCategoryOptions() {
  try {
    const token = await SapService.login();
    const response = await SapService.getData(
      "https://my360131.sapbydesign.com/sap/byd/odata/cust/v1/khcategoria/ProductCategoryHierarchyProductCategoryCollection?$format=json",
      token
    );

    return response.d.results.map((element) => ({
      label: element.Description,
      value: element.InternalID,
    }));
  } catch (error) {
    console.error("Error al obtener categorías:", error);
    return [];
  }
}
